<template>
  <div v-if="dynamicSummaryValues">
    <div
      v-for="value in dynamicSummaryValues.categories"
      :key="value.label"
      class="d-flex gap-4 justify-space-between"
    >
      <span class="text-h6">{{ value.label }}: </span>
      <span v-if="value.name" class="text-h5">{{
        `${value.name}: ${value.count} (${value.percentage}%)`
      }}</span>
      <span v-else class="text-h5">-</span>
    </div>
  </div>
  <SoProgress
    v-else
    :size="54"
    type="circular"
    data-testid="admin-complaint-dynamic-summary-loading"
    indeterminate
  />
  <div v-if="dynamicSummaryValues" class="ml-12">
    <div class="d-flex gap-4 justify-space-between">
      <span class="text-h6">Total goodwill awarded: </span>
      <span class="text-h5"
        >£{{ dynamicSummaryValues.goodWillAmountTotal }}</span
      >
    </div>
    <div class="d-flex gap-4 justify-space-between">
      <span class="text-h6">Average age: </span>
      <span class="text-h5">{{ dynamicSummaryValues.ageAverage }} days</span>
    </div>
  </div>
  <SoSkeleton v-else type="list-item" height="100" />
</template>
<script lang="ts">
  import { PropType } from "vue"
  import { ComplaintFilterTypes } from "@/views/operations/complaints/opsComplaintConfig"
  import { IDynamicComplaintSummary } from "@/mutators/complaint/ComplaintMutator.types"
  import { ComplaintService } from "@/services/operations/ComplaintService"
  import SoSkeleton from "@/components/SoSkeleton.vue"
  import SoProgress from "@/components/SoProgress.vue"
  import errorHandler from "@/services/ErrorService/errorHandler"

  export default {
    name: "OpsComplaintTableSummary",
    components: { SoProgress, SoSkeleton },
    props: {
      filters: {
        type: Object as PropType<ComplaintFilterTypes>,
        required: true,
      },
    },
    data: () => ({
      dynamicComplaintSummary: null as IDynamicComplaintSummary | null,
    }),
    computed: {
      dynamicSummaryValues() {
        if (!this.dynamicComplaintSummary) {
          return null
        }
        const {
          topCategory1,
          topCategory3,
          topCategory2,
          total,
          goodWillAmountTotal,
          ageAverage,
        } = this.dynamicComplaintSummary

        return {
          ageAverage,
          total,
          goodWillAmountTotal,
          categories: [
            {
              label: "Top category 1",
              name: topCategory1?.name,
              count: topCategory1?.count,
              percentage: !topCategory1?.count
                ? 0
                : Math.round((topCategory1.count / total) * 100),
            },
            {
              label: "Top category 2",
              name: topCategory2?.name,
              count: topCategory2?.count,
              percentage: !topCategory2?.count
                ? 0
                : Math.round((topCategory2.count / total) * 100),
            },
            {
              label: "Top category 3",
              name: topCategory3?.name,
              count: topCategory3?.count,
              percentage: !topCategory3?.count
                ? 0
                : Math.round((topCategory3.count / total) * 100),
            },
          ],
        }
      },
    },
    watch: {
      filters(filters: ComplaintFilterTypes) {
        this.dynamicComplaintSummary = null
        ComplaintService.getDynamicComplaintsSummary(filters).then(
          (value) => (this.dynamicComplaintSummary = value),
          (error) =>
            errorHandler.showCaughtError(
              error,
              "Failed to load the complaints summary.",
            ),
        )
      },
    },
  }
</script>
